import { createModule } from 'saga-slice';
import { AnalyticsState, initialState } from './stateType';
import { sendEventSagaFactory } from './sagas';

const AnalyticsSlice = createModule({
  name: 'analytics',
  initialState,
  reducers: {
    sendEvent: (state: AnalyticsState) => {
      state.loading = true;
    },
    sendEventSuccess: (state: AnalyticsState) => {
      state.loading = false;
    },
    sendEventError: (state: AnalyticsState, payload: string) => {
      state.loading = false;
      state.error = payload;
    },
  },
  sagas: (actions) => ({
    [actions.sendEvent]: sendEventSagaFactory(actions),
  }),
});

export default AnalyticsSlice;
export const AnalyticsActions = AnalyticsSlice.actions;
